import { AuthUserModel, ChangePasswordResponse, ClientDetailedInfo, ForgotPasswordResponse, GenericResponseModel, LoginRequest, changePassworRequestModel } from '../../dataModel/authModels';
import { AppointmentModel, ClientClinicInfo, ClientSignatureResp, ClientUpdatePinModel, ClientUploadSignModel, DiagnosisModel, ResponseClientTreatmentPlanSign } from '../../dataModel/clientModels';
import { DocumentRequestObj } from '../../dataModel/documentModels';
import { InboxRequestObj } from '../../dataModel/messagesModal';
import * as TYPES from './types';




export const loaderAction = (payload: Boolean) => ({
  type: TYPES['LOADER'],
  payload,
});

export const loaderActionMainApp = (payload: Boolean) => ({
  type: TYPES['LOADER_MAIN_APP'],
  payload,
});


export const loginAction = (payload: LoginRequest) => ({
  type: TYPES['LOGIN_ACTION'],
  payload,
});

export const saveAuthError = (payload?: String) => ({
  type: TYPES['AUTH_ERROR'],
  payload,
});

export const saveAuthResponse = (payload: AuthUserModel) => ({
  type: TYPES['SAVE_AUTH_RESPONSE'],
  payload,
});

export const saveClientDetailedInfo = (payload: ClientDetailedInfo) => ({
  type: TYPES['SAVE_CLIENT_DETAIL_INFO'],
  payload,
});

export const getClientSign = (payload?: any) => ({
  type: TYPES['GET_CLIENTS_SIGN'],
  payload,
});

export const saveClientSign = (payload: ClientSignatureResp[]) => ({
  type: TYPES['SAVE_CLIENTS_SIGN'],
  payload,
});

export const getClientClinic = (payload?: any) => ({
  type: TYPES['GET_CLIENT_CLINIC'],
  payload,
});

export const saveClientClnic = (payload: ClientClinicInfo) => ({
  type: TYPES['SAVE_CLIENT_CLINIC'],
  payload,
});

export const getClientDoc = (payload?: any) => ({
  type: TYPES['GET_CLIENT_DOC'],
  payload,
});

export const saveClientDoc = (payload: ClientClinicInfo) => ({
  type: TYPES['SAVE_CLIENT_DOC'],
  payload,
});

export const updateClientSigns = (payload: ClientUploadSignModel) => ({
  type: TYPES['UPDATE_CLIENT_SIGN'],
  payload,
});

export const saveGenericSuccessData = (payload: boolean) => ({
  type: TYPES['SAVE_GENERICSUCCESS'],
  payload,
});


export const updateClientSignsPIN = (payload: ClientUpdatePinModel) => ({
  type: TYPES['UPDATE_CLIENT_SIGN_PIN'],
  payload,
});

export const saveClientSignsPIN = (payload: boolean) => ({
  type: TYPES['SAVE_CLIENT_SIGN_PIN'],
  payload,
});



export const getClientDetailedInfo = (payload?: any) => ({
  type: TYPES['GET_CLIENT_DETAIL_INFO'],
  payload,
});

export const getSignedDoc = (payload: DocumentRequestObj) => ({
  type: TYPES['GET_SIGNED_DOC'],
  payload,
});

export const saveSignedDoc = (payload?: GenericResponseModel) => ({
  type: TYPES['SAVE_SIGNED_DOC'],
  payload,
});

export const getPendingDoc = (payload: DocumentRequestObj) => ({
  type: TYPES['GET_PENDING_DOC'],
  payload,
});

export const savePendingDoc = (payload?: GenericResponseModel) => ({
  type: TYPES['SAVE_PENDING_DOC'],
  payload,
});

export const getDocumentUrl = (payload?: any) => ({
  type: TYPES['GET_DOCUMENT_URL'],
  payload,
});

export const saveDocumentUrl = (payload?: string) => ({
  type: TYPES['SAVE_DOCUMENT_URL'],
  payload,
});

export const saveSignedDocResponse = (payload?: any) => ({
  type: TYPES['SAVE_SIGNED_DOC_RESP'],
  payload,
});

export const forgotPassword = (payload?: string) => ({
  type: TYPES['FORGOT_PASSWORD'],
  payload,
});

export const saveForgotPasswordResponse = (payload?: ForgotPasswordResponse | string) => ({
  type: TYPES['SAVE_FORGOT_PASSWORD_RESPONSE'],
  payload,
});

export const changePassword = (payload?: changePassworRequestModel) => ({
  type: TYPES['CHANGE_PASSWORD'],
  payload,
});

export const savechangePasswordResponse = (payload?: ChangePasswordResponse) => ({
  type: TYPES['SAVE_CHANGE_PASSWORD_RESPONSE'],
  payload,
});

export const getClientDiagnosis = (payload?: boolean) => ({
  type: TYPES['GET_CLIENT_DIAGNOSIS'],
  payload,
});

export const saveClientDiagnosis = (payload?: DiagnosisModel[]) => ({
  type: TYPES['SAVE_CLIENT_DIAGNOSIS'],
  payload,
});

export const getTreatmentPlan = (payload?: boolean) => ({
  type: TYPES['GET_TREATMENT_PLAN'],
  payload,
});

export const saveClientTreatmentPlanSign = (payload: any) => {
  return {
    type: TYPES['SAVE_CLIENT_TREATMENT_PLAN_SIGN'],
    payload,
  };
};

export const getClientAppointments = (payload?: boolean) => ({
  type: TYPES['GET_CLIENT_APPOINTMENTS'],
  payload,
});

export const saveClientAppointments = (payload?: AppointmentModel[]) => ({
  type: TYPES['SAVE_CLIENT_APPOINTMENTS'],
  payload,
});

export const getClientTreatmentPlanSign = (payload?: any) => ({
  type: TYPES['GET_CLIENT_TREATMENT_PLAN_SIGN'],
  payload
})

export const saveTreatmentPlan = (payload?: ResponseClientTreatmentPlanSign[]) => ({
  type: TYPES['SAVE_TREATMENT_PLAN'],
  payload,
});

export const ApplyClientSignature = (payload?: any) => ({
  type: TYPES['APPLY_CLIENT_SIGNATURE'],
  payload
})
export const setAppIsImpersonate = (payload?: any) => ({
  type: TYPES['SET_APP_IS_IMPERSONATE'],
  payload
})

export const setMessageLoading = (payload?: any) => ({
  type: TYPES['SET_MESSAGE_LOADING'],
  payload
})

export const getMessagesList = (payload: InboxRequestObj) => ({
  type: TYPES['GET_MESSAGES'],
  payload,
});

export const saveMessagesList = (payload: any) => ({
  type: TYPES['SAVE_MESSAGES'],
  payload,
});

export const getUnreadMessageCount = (payload?: any) => ({
  type: TYPES['GET_UNREAD_MESSAGES'],
  payload,
});

export const saveUnreadMessageCount = (payload?: number) => ({
  type: TYPES['SAVE_UNREAD_MESSAGES'],
  payload,
});

export const markMessageAsRead = (payload: any) => ({
  type: TYPES['MARK_MESSAGE_READ'],
  payload,
});

export const setMessageListToBack = (payload: number) => (
  {
  type: TYPES['SET_MESSAGE_LIST_BACK'],
  payload,
});

export const getLinkedAccountList = () => (
  {
  type: TYPES['GET_LINKED_ACCOUNT_LIST'],
  
});

export const setLinkedAccountList = (payload: any) => (
  {
  type: TYPES['SET_LINKED_ACCOUNT_LIST'],
  payload,
});

export const getParentInfo = () => (
  {
  type: TYPES['GET_PARENT_INFO'],
  
});

export const saveParentInfo = (payload: any) => (
  {
  type: TYPES['SAVE_PARENT_INFO'],
  payload,
});

export const getClientQuestionnaires = (payload: any) => (
  {
  type: TYPES['GET_CLIENT_QUESTIONNAIRES'],
  payload,
});

export const saveClientQuestinnaires = (payload: any) => (
  {
  type: TYPES['SAVE_CLIENT_QUESTIONNAIRES'],
  payload,
});

export const saveClientPendingQuestionnaires = (payload: any) => (
  {
  type: TYPES['SAVE_CLIENT_PENDING_QUESTIONNAIRES'],
  payload,
});


export const getTreatmentPlanReSignNotifications = (payload?: boolean) => ({
  type: TYPES['GET_CP_RESIGN_NOTIFICATION'],
  payload,
});

export const saveTreatmentPlanReSignNotifications = (payload?: ResponseClientTreatmentPlanSign[]) => ({
  type: TYPES['SAVE_CP_RESIGN_NOTIFICATION'],
  payload,
});

export const saveDocIsLocked = (payload?:boolean) => ({
  type: TYPES['SAVE_DOC_IS_LOCKED'],
  payload,
});

export const saveIsClientFillable = (payload?:boolean) => ({
  type: TYPES['SAVE_IS_CLIENT_FILLABLE'],
  payload,
});



